export function* root() {}

export const saga = {
  id: 'sloyd.bootstrap',
  type: 'bootstrap',
  root: root,
  trigger: {},
};
